import VueI18n from 'vue-i18n'
import { RouteConfig } from 'vue-router'

const AppModulesView: DynamicImport = () => import(/* webpackChunkName: "subscriptions" */ '../views/AppModulesView.vue')
const AppModuleView: DynamicImport = () => import(/* webpackChunkName: "subscriptions" */ '../views/AppModuleView.vue')
const PaymentSuccessfulView: DynamicImport = () => import(/* webpackChunkName: "subscriptions" */ '../views/PaymentSuccessfulView.vue')
const PaymentMethodSuccessfullyUpdatedView: DynamicImport = () => import(/* webpackChunkName: "subscriptions" */ '../views/PaymentMethodSuccessfullyUpdatedView.vue')
const TeamSubscriptionManagementView: DynamicImport = () => import(/* webpackChunkName: "subscriptions" */ '../views/TeamSubscriptionManagementView.vue')
const MyAccountantView: DynamicImport = () => import(/* webpackChunkName: "subscriptions" */ '../views/MyAccountantView.vue')
const SponsorshipView: DynamicImport = () => import(/* webpackChunkName: "subscriptions" */ '../views/SponsorshipView.vue')

const configRoutes: (i18n: VueI18n) => RouteConfig[] = () => ([
  {
    name: 'app-modules',
    path: 'app-modules',
    component: AppModulesView,
    meta: {
      title: 'Gestion des modules',
      userPermission: ['manage-subscription', 1]
    }
  },
  {
    name: 'app-module',
    path: 'app-modules/:module',
    component: AppModuleView,
    meta: {
      title: 'Gestion des modules',
      pageHeader: false
    }
  },
  {
    name: 'subscription-checkout',
    path: 'subscription/checkout',
    component: PaymentSuccessfulView,
    meta: {
      title: 'Confirmation de paiement',
      pageHeader: false,
      userPermission: ['manage-subscription', 1],
      appActivePayment: true
    }
  },
  {
    name: 'payment-method-checkout',
    path: 'subscription/payment-method/checkout',
    component: PaymentMethodSuccessfullyUpdatedView,
    meta: {
      title: 'Modification du moyen de paiement',
      pageHeader: false,
      userPermission: ['manage-subscription', 1],
      appActivePayment: true
    }
  },
  {
    name: 'subscription-manage',
    path: 'subscription/manage',
    component: TeamSubscriptionManagementView,
    meta: {
      title: 'Mon abonnement',
      userPermission: ['manage-subscription', 1],
      appActivePayment: true
    }
  },
  {
    name: 'my-accountant',
    path: 'accounting/my-accountant',
    component: MyAccountantView,
    meta: {
      title: 'Expert comptable',
      userPermission: ['app-configuration', 1]
    }
  },
  {
    name: 'sponsorship',
    path: 'subscription/sponsorship',
    component: SponsorshipView,
    meta: {
      title: 'Parrainage',
      userPermission: ['manage-subscription', 1],
      appActiveSponsorship: true
    }
  }
])

export default configRoutes
